import React, { ComponentType } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "~/const/route";
import { RootState } from "~/redux/rootReducer";

type RouteType = {
  path: string;
  component: ComponentType<any>;
};

// 専門家
export const NoAuthSpecialist: React.VFC<RouteType> = (props) => {
  const specialistAuth = useSelector(
    (state: RootState) => state.specialistAuth
  );
  if (!specialistAuth.login) {
    return <Route exact path={props.path} component={props.component} />;
  } else {
    return <Redirect to={ROUTES.SPECIALIST.HOME} />;
  }
};
export const AuthSpecialist: React.VFC<RouteType> = (props) => {
  const specialistAuth = useSelector(
    (state: RootState) => state.specialistAuth
  );
  if (specialistAuth.login || !specialistAuth.isInit) {
    return <Route exact path={props.path} component={props.component} />;
  } else {
    return <Redirect to={ROUTES.SPECIALIST.LOGIN} />;
  }
};

// 運営会社
export const NoAuthAdmin: React.VFC<RouteType> = (props) => {
  const adminAuth = useSelector((state: RootState) => state.adminAuth);
  if (!adminAuth.login) {
    return <Route exact path={props.path} component={props.component} />;
  } else {
    return <Redirect to={ROUTES.ADMIN.SPECIALIST} />;
  }
};
export const AuthAdmin: React.VFC<RouteType> = (props) => {
  const adminAuth = useSelector((state: RootState) => state.adminAuth);
  if (adminAuth.login || !adminAuth.isInit) {
    return <Route exact path={props.path} component={props.component} />;
  } else {
    return <Redirect to={ROUTES.ADMIN.LOGIN} />;
  }
};
